'use strict';

export class MainScript {

    constructor() {
        this.initEvent();
    }

    initEvent() {
        const instance = this

        $(document).on('click', '.js-filter-toggle', function () {
            let sectionCode = $(this).attr('data-section-code')
            $(this).parent('li').siblings().children('.js-filter-toggle').removeClass('active')
            $(this).addClass('active')
            instance.loadFilter(sectionCode)
        });
    }

    loadFilter(sectionCode)
    {
        $.ajax({
            url: '/local/ajax/main_page_filter.php?section_code=' + sectionCode,
            success: function (data) {
                if (sectionCode === 'glempings') {
                    $('#tb-1').html(data);
                    $('#tb-2').html('');
                } else {
                    $('#tb-1').html('');
                    $('#tb-2').html(data);
                }
            },
            error: function (e) {
                alert(e);
            }
        })
    }
}